import { 
    useState, 
    useEffect, 
    useMemo, 
    useRef,
    useCallback,
  }                           from 'react';
import { connect }            from 'react-redux';
import { reducerType }        from 'reducer';
import Buttons                from './Buttons';
import TopBar                 from './TopBar';
import ImageContainer         from './ImageContainer';
import useGetPath             from 'functions/useGetPath';
import useShowScoresIcon      from './useShowScoresIcon';
import useGetUnitValues       from './useGetUnitValues';
import useScrollIntoView      from './useScrollIntoView';
import { contentInfoType }    from 'types'
import { colors }             from 'utils/colors'

import { makeStyles }         from 'makeStyles';

var clsx = require('classnames')

const useStyles = makeStyles()(() => ({
    root: {
      height:          320,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-evenly',
      flexFlow:        'column',
      transition:      'opacity 0.2s',
    },
    inner: {
      //height:          290,
      //width:           270,
      borderRadius:    '0.5em',
      border:          `1px solid #CCC`,
      transition:      'height 0.2s, width 0.2s',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      backgroundColor: '#FFF',
      overflow:        'hidden',
      
    },
    hoverEffect: {
      height:  290,
      width:   270,
      '&:hover': {
        height: 315,
        width:  295,
      }
    },
    noHoverEffect: {
      height:  250,
      width:   230,
    }
}))

type UnitProps = {
  ind:             number;
  gridOpacity:     number;
  lang:            string;
  manualVal:       string;
  activityUpdated: boolean;
  guest:           boolean;
  groupUrl:        boolean;
  homePageApp?:    boolean;
  val:             contentInfoType;
  hash:            contentInfoType;
}

const Unit: React.FC<UnitProps> = ({
  ind,
  gridOpacity,
  lang,
  manualVal,
  activityUpdated,
  guest,
  groupUrl,
  homePageApp,
  val,
  hash,
}) => {

  const { classes } = useStyles();


  const [initialPos, setInitialPos] = useState(false)
  const [hover, setHover]           = useState('')
  const [mouseEnter, setMouseEnter] = useState(false)
  const [update, setUpdate]         = useState(false)


  const UnitRef = useRef<HTMLDivElement>(null);
 


  useEffect(() => {

    setTimeout(() => {
      setInitialPos(true)
    }, 10)
  },[])



  useEffect(() => {
    if ( guest || activityUpdated ) {
      setUpdate(true)
    }
  },[activityUpdated, guest])


   useScrollIntoView(val, UnitRef);

   const path = useGetPath(val)

   const { id, showTopBar, backgroundColor, showDescriptionButton, appName, showLikes, showStar, showHeart, disabled, disabledGrade, showApproved } = useGetUnitValues(val, groupUrl, update)
   const showScoresIcon  = useShowScoresIcon(hash, val, guest, update)




const favoriteStatus = useMemo(() => {
  if (guest || !activityUpdated || !hash[id] || isNaN(+(hash[id].selected))) {
    return 0; // treat as not-favorited yet
  }
  return +(hash[id].selected);
}, [id, hash, activityUpdated, guest]);


const handleFavoriteClick = useCallback((status: number, id: string) => {
  if (status === -1) return; // keep your guard if -1 has special meaning
  const action = status <= 0 ? 'add_to_favorites' : 'remove_from_favorites';
  import('functions/actions/handle_like').then(mod => {
    // support both default and named exports + snake/camel
    const fn =
      (mod as any).handleLike ||
      (mod as any).handle_like ||
      (mod as any).default;
    if (typeof fn === 'function') {
      fn(id, action);
    } else {
      console.error('handle_like not exported correctly from functions/actions/handle_like.ts');
    }
  });
}, []);





  const rootStyle = useMemo(() => {

    const id = val.uid ? `${ val.uid }` : val.lesson_id;

    return {
      border:  manualVal === id ? `4px solid ${ colors.blue }` : undefined,
      opacity: initialPos ? gridOpacity : 0,
      height:  homePageApp ? 250 : undefined,
    }
  },[val, manualVal, initialPos, gridOpacity, homePageApp])


  return (
    <div 
      dir       = 'rtl'
      className = { classes.root }
      ref       = { UnitRef }
      style     = { rootStyle }
    >
        <div 
          className    = { clsx(classes.inner, (homePageApp ? classes.noHoverEffect : classes.hoverEffect)) }
          onMouseEnter = { () => { setMouseEnter(true) } }
          onMouseLeave = { () => { setMouseEnter(false) } }
          style        = {{
            opacity: (disabled || disabledGrade) ? 0.4 : 1
          }}
        >
           {
             showTopBar
             &&
             <TopBar
              id                  = { id }
              lang                = { lang }
              guest               = { guest }
              backgroundColor     = { backgroundColor }
              activityUpdated     = { update }
              showStar            = { showStar }
              showHeart           = { showHeart && !showScoresIcon }
              showLikes           = { showLikes }
              showScoresIcon      = { showScoresIcon }
              homePageApp         = { !!homePageApp ? homePageApp : false }
              val                 = { val }
              disabled            = { disabled }
              mouseEnter          = { mouseEnter }
              favoriteStatus      = { favoriteStatus }
              hash                = { hash }
              groupUrl            = { groupUrl }
              handleFavoriteClick = { handleFavoriteClick }
             />
           }
           <ImageContainer
               appName        = { appName }
               path           = { path }
               val            = { val }
               guest          = { guest }
               disabled       = { disabled }
               showApproved   = { showApproved }
           />
           {
             !groupUrl && showDescriptionButton
             &&
             <Buttons
                lang                  = { lang }
                backgroundColor       = { backgroundColor }
                val                   = { val }
                hover                 = { hover }
                disabled              = { disabled }
                disabledGrade         = { disabledGrade }
                showDescriptionButton = { showDescriptionButton }
                manualVal             = { manualVal }
                setHover              = { setHover }
             />
           }
        </div>
    </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {
  const userInfo = reducer.data.userInfo;
  // Check multiple indicators for guest status (same logic as useGetUserGuestStatus):
  // 1. Email is guest email or empty
  // 2. semelMosad is 'guest' (from PHP response)
  // 3. userFoundInTables includes 'guest_identity' (from PHP response)
  const emailIsGuest = userInfo.userEmail === 'guest@yisumatica.org.il' || userInfo.userEmail === '';
  const semelIsGuest = userInfo.semelMosad === 'guest';
  const foundAsGuest = Array.isArray(userInfo.userFoundInTables) && userInfo.userFoundInTables.includes('guest_identity');
  const guest = emailIsGuest || semelIsGuest || foundAsGuest;
  
  // Removed console.log to prevent endless logging
  // If debugging is needed, use conditional logging:
  // if (process.env.NODE_ENV === 'development' && Math.random() < 0.01) {
  //   console.log('[GUEST STATUS] Unit mapStateToProps:', { guest, emailIsGuest, semelIsGuest, foundAsGuest });
  // }

  return {
    lang:            reducer.components.lang,
    hash:            reducer.content.hash,
    activityUpdated: reducer.data.dataUpdateState.activity,
    guest:           guest,
    manualVal:       reducer.manualNav.manualVal
}};


export default connect(mapStateToProps)(Unit);




